<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Insurance & Coverages</h1>
              <img
                src="../../../public/assets/images/ice_blue_shield.png"
                class="title-section-img form-title-img ice_blue_shield"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">29.</span>Current Coverage: Is the Applicant's firm currently insured for professional liability (E&O)?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="isFirmCurrentlyInsured"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quote.isFirmCurrentlyInsured"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="isFirmCurrentlyInsured"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.isFirmCurrentlyInsured"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('isFirmCurrentlyInsured')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('isFirmCurrentlyInsured') | filterText }}</span>
                  </div>
                <p v-show="quote.isFirmCurrentlyInsured === 'true' || quote.isFirmCurrentlyInsured == true" class="input-info pt-25">
                  <i class="fas fa-exclamation-triangle not-eligible"></i>
                  <span v-if="getApplicantType === 'RWS'"
                    class="not-eligible-text"
                  >A copy of your current policy declarations page showing your policy's retroactive date is required to receive prior acts coverage. Please email: info@rwsinsurance.com.</span>
                  <span v-else-if="getApplicantType === 'RISKPRO'"
                        class="not-eligible-text"
                  >A copy of your current policy declarations page showing your policy's retroactive date is required to receive prior acts coverage. Please email: RISKPRO@liabilityinsuranceapps.com.</span>
                  <span v-else
                    class="not-eligible-text"
                  >A copy of your current policy declarations page showing your policy's retroactive date is required to receive prior acts coverage. Please email: inspectors@orep.org.</span>
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">30.</span>Select Desired Coverage:
              </label>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="desiredCoverage"
                    id="claim-three"
                    value="1M/1M"
                    class="orep-radio"
                    :checked="quote.desiredCoverage.find(coverage => coverage === '1M/1M')"
                    v-validate="'required|included:1M/1M,0.5M/0.5M,0.1M/0.3M,0.3M/0.3M,other'"
                    @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$1,000,000 Per Claim / $1,000,000 Aggregate</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="desiredCoverage"
                    id="claim-two"
                    value="0.5M/0.5M"
                    class="orep-radio"
                    :checked="quote.desiredCoverage.find(coverage => coverage === '0.5M/0.5M')"
                    @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$500,000 Per Claim / $500,000 Aggregate</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="desiredCoverage"
                    id="claim-four"
                    value="0.3M/0.3M"
                    class="orep-radio"
                    :checked="quote.desiredCoverage.find(coverage => coverage === '0.3M/0.3M')"
                    @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$300,000 Per Claim / $300,000 Aggregate</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="desiredCoverage"
                    id="claim-one"
                    value="0.1M/0.3M"
                    class="orep-radio"
                    :checked="quote.desiredCoverage.find(coverage => coverage === '0.1M/0.3M')"
                    @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">$100,000 Per Claim / $300,000 Aggregate</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="desiredCoverage"
                    id="claim-other"
                    value="other"
                    class="orep-radio"
                    :checked="quote.desiredCoverage.find(coverage => coverage === 'other')"
                    @change="validateBeforeSubmit() + desiredCoverage($event)"
                  >
                  <span class="radio-span solo-checkbox-span">other</span>
                </label>
              </div>
              <span
                v-show="errors.has('desiredCoverage')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('desiredCoverage') | filterText }}</span>
              <input
                type="text"
                class="orep-text-input"
                name="desiredCoverageCustomLimit"
                placeholder="Request a different Limit:"
                v-if="quote.desiredCoverage.find(coverage => coverage === 'other')"
                v-model="quote.desiredCoverageCustomLimit"
              >
            </article>
            <article class="input-section form-section">
              <div class="inline-toggle-label">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">31.</span>$1,500 / $2,500 Program Retention:
                </label>
                <div class="radio orep-radio-wrapper solo-checkbox m-0">
                  <label>
                    <input
                      type="checkbox"
                      name="deductible"
                      value
                      class="orep-radio position-relative"
                      v-model="quote.requestQuoteWithDollar5000Deductible">
                    <span
                      class="radio-span solo-checkbox-span"
                    >Request quote with $5,000 Retention.</span>
                  </label>
                </div>
              </div>
              <p class="input-info">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>Standard Retention is $2,500. A $1,500 Retention will be automatically offered at no additional premium to applicants who qualify, based on experience, claims history and other underwriting.</span>
              </p>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">32.</span>Additional Inspection-Related Coverage(s)
              </label>

              <div class="row">
                <div class="col-md-11">
                  <p
                    class="eo"
                  >This E&O policy includes the following coverage endorsements built into the base policy:</p>
                  <ul class="eo-list list-reset">
                    <li>
                      <i class="fas fa-check"></i>General Liability Coverage
                    </li>
                    <li>
                      <i class="fas fa-check"></i>Referral Coverage / Blanket Additional Insured
                    </li>
                    <li>
                      <i class="fas fa-check"></i>Personal Injury
                    </li>
                    <li>
                      <i class="fas fa-check"></i>Loss of Earnings
                    </li>
                    <li>
                      <i class="fas fa-check"></i>Coverage for Civil, administrative or regulatory investigation against any "insured" commenced by the filing of a notice of charges, investigative order or similar document; or "disciplinary proceeding".
                    </li>
                  </ul>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5"></span>Additional Inspection-Related Coverage(s)
              </label>
              <p v-if="getApplicantType === 'RWS'" class="input-info">
                <i class="fas fa-exclamation-triangle not-eligible"></i>
                <span class="not-eligible-text">
                  Coverages are included at No Additional Premium except where noted. Please check coverages/services you provide. Please forward to
                  <strong>info@rwsinsurance.com</strong> your background, training, experience, certification or licensing with the services/tests selected.
                </span>
              </p>
              <p v-else-if="getApplicantType === 'RISKPRO'" class="input-info">
                <i class="fas fa-exclamation-triangle not-eligible"></i>
                <span class="not-eligible-text">
                  Coverages are included at No Additional Premium except where noted. Please check coverages/services you provide. Please forward to
                  <strong>RISKPRO@liabilityinsuranceapps.com</strong> your background, training, experience, certification or licensing with the services/tests selected.
                </span>
              </p>

              <p v-else class="input-info">
                <i class="fas fa-exclamation-triangle not-eligible"></i>
                <span class="not-eligible-text">
                  Coverages are included at No Additional Premium except where noted. Please check coverages/services you provide. Please forward to
                  <strong>inspectors@orep.org</strong> your background, training, experience, certification or licensing with the services/tests selected.
                </span>
              </p>

              <div class="row">
                <div class="col-md-6">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.poolAndSpaInspection"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Pool & Spa Inspection</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.airQualityTesting"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Air Quality Testing</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.infraredThermalInspections"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Infrared Thermal Inspections</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.LeadPaintInspections"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Lead Paint Inspections</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.exteriorInsulationFinishSystemsInspections"
                      >
                      <span
                        class="radio-span solo-checkbox-span no-top"
                      >Exterior Insulation Finish Systems (EIFS) Inspections</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.greenBuildingInspections"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Green Building Inspections</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.windMitigationInspections"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Wind Mitigation Inspections</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.radonInspectionEndorsement"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Radon Inspection Endorsement</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.termiteWdiLiabilityIncidentalOnly"
                      >
                      <span
                        class="radio-span solo-checkbox-span no-top"
                      >Termite/WDI Liability (Incidental Only)</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.carbonMonoxide"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Carbon Monoxide</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.rodentInspections"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Rodent Inspections</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.energyRating"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Energy Rating</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.drone"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Drone</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.septicWaterTestingSewerScoping"
                      >
                      <span
                        class="radio-span solo-checkbox-span no-top"
                      >Septic/Water Testing / Sewer Scoping (Adds 5% Premium)</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        name="deductible"
                        value
                        class="orep-radio position-relative"
                        v-model="quote.moldTesting"
                      >
                      <span class="radio-span solo-checkbox-span no-top">Mold Testing (Adds 15% Premium)</span>
                    </label>
                  </div>
<!--                  <div class="radio orep-radio-wrapper solo-checkbox">-->
<!--                    <label class="d-flex align-items-center">-->
<!--                      <input-->
<!--                        type="checkbox"-->
<!--                        name="deductible"-->
<!--                        value-->
<!--                        class="orep-radio position-relative"-->
<!--                        v-model="quote.cyberProtection"-->
<!--                      >-->
<!--                      <span-->
<!--                        class="radio-span solo-checkbox-span no-top"-->
<!--                      >Cyber Protection: I would like information on Cyber Coverage ($89 for $100,000 limits; $59 for $50,000 limits)</span>-->
<!--                    </label>-->
<!--                  </div>-->
                </div>
                <p
                  v-show="      quote.poolAndSpaInspection || quote.airQualityTesting || quote.infraredThermalInspections || quote.LeadPaintInspections || quote.exteriorInsulationFinishSystemsInspections || quote.greenBuildingInspections || quote.windMitigationInspections || quote.radonInspectionEndorsement || quote.termiteWdiLiabilityIncidentalOnly || quote.carbonMonoxide || quote.rodentInspections || quote.energyRating || quote.drone || quote.septicWaterTestingSewerScoping || quote.moldTesting"
                  class="input-info pt-25"
                >
                  <input
                    type="checkbox"
                    name="deductible"
                    value
                    class="orep-radio position-relative"
                    v-model="quote.attestation"
                  >
                  <span
                    class="not-eligible-text"
                    style="padding-left: 12px"
                  ><strong>Attestation:</strong> I attest I have the training and/or experience to perform these services professionally and competently.</span>
                </p>
              </div>
            </article>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Loss History</h1>
              <img
                src="../../../public/assets/images/piggy-bank.png"
                class="title-section-img form-title-img piggy-bank"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">33.</span>Is any person or entity proposed for insurance aware of any act, error or omission or misstatement, misleading statement or personal injury offense that occurred within the past 5 years which might give rise to a claim(s) under the proposed policy?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="knowledgeOfActEoPotentialClaimFuture"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quote.knowledgeOfActEoPotentialClaimFuture"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="knowledgeOfActEoPotentialClaimFuture"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.knowledgeOfActEoPotentialClaimFuture"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('knowledgeOfActEoPotentialClaimFuture')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('knowledgeOfActEoPotentialClaimFuture') | filterText }}</span>
                  </div>
                <p
                  v-show="quote.knowledgeOfActEoPotentialClaimFuture === 'true' || quote.knowledgeOfActEoPotentialClaimFuture == true"
                  class="input-info pt-25"
                >
                  <i class="fas fa-exclamation-triangle not-eligible"></i>
                  <span v-if="getApplicantType === 'RWS'"
                    class="not-eligible-text"
                  >Please email a detailed description to info@rwsinsurance.com of such act, error or omission and an explanation of why to a claim may arise.</span>
                  <span v-else-if="getApplicantType === 'RISKPRO'"
                    class="not-eligible-text"
                  >Please email a detailed description to RISKPRO@liabilityinsuranceapps.com of such act, error or omission and an explanation of why to a claim may arise.</span>
                  <span v-else
                    class="not-eligible-text"
                  >Please email a detailed description to inspectors@orep.org of such act, error or omission and an explanation of why to a claim may arise.</span>
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">34.</span>Has any person or entity proposed for this insurance been the subject of any professional liability claims, circumstance or potential claim during the past five years?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="hasBeenSubjectToEoClaimPast"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quote.hasBeenSubjectToEoClaimPast"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="hasBeenSubjectToEoClaimPast"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.hasBeenSubjectToEoClaimPast"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('hasBeenSubjectToEoClaimPast')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('hasBeenSubjectToEoClaimPast') | filterText }}</span>
                  </div>
                <p v-show="quote.hasBeenSubjectToEoClaimPast === 'true' || quote.hasBeenSubjectToEoClaimPast == true" class="input-info pt-25">
                  <i class="fas fa-exclamation-triangle not-eligible"></i>
                  <span v-if="getApplicantType === 'RWS'"
                    class="not-eligible-text"
                  >Please email your loss-runs to info@rwsinsurance.com or complete the table below. Loss runs can be obtained from your current insurer.</span>
                  <span v-else-if="getApplicantType === 'RISKPRO'"
                    class="not-eligible-text"
                  >Please email your loss-runs to RISKPRO@liabilityinsuranceapps.com or complete the table below. Loss runs can be obtained from your current insurer.</span>
                  <span v-else
                    class="not-eligible-text"
                  >Please email your loss-runs to inspectors@orep.org or complete the table below. Loss runs can be obtained from your current insurer.</span>
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pl-0 pr-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">35.</span>Have you or anyone in your firm ever been criticized, censored, reprimanded or had any license suspended or revoked by any professional organization, regulatory agency or court?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="criticizedCensoredSuspendedRevoked"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quote.criticizedCensoredSuspendedRevoked"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="criticizedCensoredSuspendedRevoked"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.criticizedCensoredSuspendedRevoked"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('criticizedCensoredSuspendedRevoked')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('criticizedCensoredSuspendedRevoked') | filterText }}</span>
                  </div>
                <p
                  v-show="quote.criticizedCensoredSuspendedRevoked === 'true' || quote.criticizedCensoredSuspendedRevoked == true"
                  class="input-info pt-25"
                >
                  <i class="fas fa-exclamation-triangle not-eligible"></i>
                  <span v-if="getApplicantType === 'RWS'"
                    class="not-eligible-text"
                  >Please email a detailed description to info@rwsinsurance.com</span>
                  <span v-if="getApplicantType === 'RISKPRO'"
                    class="not-eligible-text"
                  >Please email a detailed description to RISKPRO@liabilityinsuranceapps.com</span>
                  <span v-else
                    class="not-eligible-text"
                  >Please email a detailed description to inspectors@orep.org</span>
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">36.</span>During the past five years, has any insurance company denied, cancelled or non-renewed your professional liability insurance?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="insuranceDeniedCancelledNonrenewedInsurance"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quote.insuranceDeniedCancelledNonrenewedInsurance"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="insuranceDeniedCancelledNonrenewedInsurance"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.insuranceDeniedCancelledNonrenewedInsurance"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('insuranceDeniedCancelledNonrenewedInsurance')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('insuranceDeniedCancelledNonrenewedInsurance') | filterText }}</span>
                  </div>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please provide details"
                  v-if="quote.insuranceDeniedCancelledNonrenewedInsurance === 'true' || quote.insuranceDeniedCancelledNonrenewedInsurance == true"
                  name="insuranceDeniedCancelledNonrenewedInsuranceDetails"
                  v-model="quote.insuranceDeniedCancelledNonrenewedInsuranceDetails"
                >
              </div>
            </article>
<!--            <article class="form-heading title-section form-section flex">-->
<!--              <h1 class="form-title">Current Declarations Page</h1>-->
<!--              <img-->
<!--                src="../../../public/assets/images/file.png"-->
<!--                class="title-section-img form-title-img file-img"-->
<!--                alt="background image"-->
<!--              >-->
<!--            </article>-->
<!--            <article class="input-section form-section">-->
<!--              <div class="d-flex flex-column">-->
<!--                <label for class="orep-label">-->
<!--                  <span class="qtn mrpx-5">39.</span>-->
<!--                   If you have current coverage, please upload your current Declarations Page.-->
<!--                </label>-->
<!--                <div class="d-flex align-items-center mb-3">-->
<!--                  <label-->
<!--                    for="coverageFile"-->
<!--                    class="d-flex justify-content-between align-items-center mt-0 upload-btn spaced mont text-uppercase"-->
<!--                    style="cursor: pointer;"-->
<!--                  >-->
<!--                    upload-->
<!--                    <i class="fas fa-cloud-upload-alt pull-right"></i>-->
<!--                  </label>-->
<!--                  <span class="ml-3" style="font-size: 16px;">-->
<!--                    {{fileName}}-->
<!--                  </span>-->
<!--                </div>-->
<!--                <input type="file" id="coverageFile" class="d-none">-->
<!--              </div>-->
<!--              <p class="input-info">-->
<!--                If you don’t have it handy, please email it to-->
<!--                <a href="mailto:inspectors@orep.org" target="_top" class="pl-2 pr-2">inspectors@orep.org</a>-->
<!--                after submitting this application.-->
<!--              </p>-->
<!--            </article>-->
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" :disabled="!state.pageThreeIsValid" @click="next('home-inspector-4')"></button>
              <button class="pagination-dots" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid" @click="next('home-inspector-5')" v-if="!state.signedInUser" ></button>
              <button class="pagination-dots" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid" @click="next('home-inspector-6')"></button>
              <button class="pagination-dots" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid" @click="next('home-inspector-7')" v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="next('home-inspector-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from "jquery";

export default {
  name: "home-inspector-3",
  data() {
    return {
      fileName: ''
    };
  },
  computed: {
    quote() {
      return this.$store.state.homeInspector.quote;
    },

    state() {
      return this.$store.state.homeInspector;
    },
    errorMsg() {
      return this.$store.state.homeInspector.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/home-inspector-ibd/' || first === '/portal/home-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
        return 'IBD';
      }else if (first === '/portal/home-inspector-rws/' || first === '/portal/home-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
        return 'RWS';
      }else if (first === '/portal/home-inspector-spmga/' || first === '/portal/home-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
        return 'SPMGA';
      }
      else if (first === '/riskpro/home-inspector/' || first === '/RISKPRO/home-inspector/' || this.quote.customer.partnerName === 'RISKPRO'){
        return 'RISKPRO';
      }
      else {
        return 'OREP';
      }
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg,
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.quote.desiredCoverage.find(coverage => coverage === event.target.value)) {
        if (this.quote.desiredCoverage.length < 1) {
          this.quote.desiredCoverage.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 coverages.'
          });
          event.target.checked = false
        }
      } else {
        this.quote.desiredCoverage = this.quote.desiredCoverage.filter(coverage => coverage !== event.target.value);
      }
    },

    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    checkServices(service) {
      return this.quote.applicantOrAssociateReportMode.includes(service);
    },

    prev() {
      this.$router.push({
        name: "home-inspector-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "home-inspector-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },

    // handleFileSelect(event) {
    //   return new Promise((resolve, reject) => {
    //     const file = event.target.files[0];
    //     const reader = new FileReader();
    //
    //     this.fileName = file.name;
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result);
    //     reader.onerror = error => reject(error);
    //   });
    // }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
    }, 500);

    // document.getElementById('coverageFile').addEventListener('change', event => {
    //   this.handleFileSelect(event).then(
    //     data => this.quote.coverageFile = data
    //   )
    // }, false);
  },
  components: {}
};
</script>

